import PropTypes from 'prop-types';
import Button from '@veeva/corgix/button';
import { css } from '@emotion/core';
import Dialog from '../Dialog';
import useMessageService from '../../services/i18n/useMessageService';

function LogOutWarningDialog({ secondsRemaining, onContinue, onLogOut }) {
    const [
        [
            sessionTimeoutDialogTitle = 'Your session is about to expire',
            sessionTimeoutDialogBody = 'The current session is about to expire in {0} seconds. Would you like to continue the session?',
            sessionTimeoutDialogContinue = 'Continue',
            sessionTimeoutDialogLogOut = 'Log Out',
        ],
        messagesLoading,
    ] = useMessageService([
        'my_account.session_timeout_dialog_title',
        'my_account.session_timeout_dialog_body',
        'my_account.session_timeout_dialog_continue',
        'my_account.session_timeout_dialog_log_out',
    ]);

    const actions = [
        <Button
            css={({ blue }) =>
                css`
                    color: ${blue};

                    &:not([disabled]):hover,
                    &:not([disabled]):focus,
                    &:not([disabled]):active {
                        color: ${blue};
                    }
                `
            }
            key="continue"
            variant="ghost"
            onClick={onContinue}
        >
            {sessionTimeoutDialogContinue}
        </Button>,
        <Button key="log-out" variant="primary" onClick={onLogOut}>
            {sessionTimeoutDialogLogOut}
        </Button>,
    ];

    if (messagesLoading) {
        return null;
    }

    // Omit decimals and don't display "-1";
    const secondsRemainingLabel = Math.max(Math.floor(secondsRemaining), 0);

    const [startBodyContent, endBodyContent] = sessionTimeoutDialogBody.split('{0}');
    return (
        <Dialog title={sessionTimeoutDialogTitle} actions={actions} open>
            {startBodyContent}
            <b>{secondsRemainingLabel}</b>
            {endBodyContent}
        </Dialog>
    );
}

LogOutWarningDialog.propTypes = {
    onContinue: PropTypes.func,
    onLogOut: PropTypes.func,
    secondsRemaining: PropTypes.number.isRequired,
};

export default LogOutWarningDialog;
